/**
 * The Youbora library (`youboralib`) is bundled with the application, so there
 * is no remote script to inject here. This module only exists to satisfy the
 * engine-descriptor `bootMethod` contract used by the other engines.
 */
export default () => {};
